(ns frontend.ui.page.lp-report-editor.step-8-archived.sub
  (:require
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]))

(def report-tab-path (conj editor-sub/editor-path :archived-report-tab))


